import { getPrimaryConfig, isDevLikeEnv } from "@crystal/config";
import { useMemoryData, evaluateConfig } from "@crystal/core";
import { createGlassHttp } from "@crystal/glass-bridge";
const AB_TESTING_PATH = "/personalizationengine";
const CACHE_KEY = "ab-testing";
const dataStore = useMemoryData("crystal_abTestingDataCache", () => /* @__PURE__ */ new Map());
const promiseStore = useMemoryData("crystal_abTestingPromiseCache", () => /* @__PURE__ */ new Map());
async function fetchMonetateData(payload) {
  const cacheData = dataStore().get(CACHE_KEY);
  const pendingPromise = promiseStore().get(CACHE_KEY);
  if (cacheData)
    return Promise.resolve(cacheData);
  if (pendingPromise)
    return pendingPromise;
  const { post } = createGlassHttp();
  const { env } = evaluateConfig(getPrimaryConfig());
  const promise = post(AB_TESTING_PATH, payload);
  const finalPromise = promise.then((data) => {
    dataStore().set(CACHE_KEY, data);
    return data;
  }).catch((err) => {
    promiseStore().delete(CACHE_KEY);
    if (isDevLikeEnv(env)) {
      console.error(err);
    }
    return Promise.reject(err);
  });
  promiseStore().set(CACHE_KEY, finalPromise);
  return finalPromise;
}
export {
  fetchMonetateData
};
//# sourceMappingURL=api.js.map
